export default __webpack_public_path__ + "static/program-circle-upcycled-en-996a87af82a21e6c6870695a4d74e85a.svg";